/**
 * LocationPicker
 *
 * Mini Mapbox GL map embedded in the ContributorPortal.
 * User clicks or drags a marker to set coordinates.
 */
import { useEffect, useRef } from 'react';
import mapboxgl from 'mapbox-gl';

mapboxgl.accessToken = import.meta.env.VITE_MAPBOX_TOKEN;

export default function LocationPicker({ onLocationPick, initialCoords }) {
  const containerRef = useRef(null);
  const mapRef = useRef(null);
  const markerRef = useRef(null);

  useEffect(() => {
    const map = new mapboxgl.Map({
      container: containerRef.current,
      style: 'mapbox://styles/mapbox/dark-v11',
      center: initialCoords || [0, 20],
      zoom: initialCoords ? 10 : 2,
      attributionControl: false,
    });

    // Create a draggable marker
    const marker = new mapboxgl.Marker({ color: '#f97316', draggable: true })
      .setLngLat(initialCoords || [0, 20])
      .addTo(map);

    // If initial coords exist, notify parent
    if (initialCoords) {
      onLocationPick({ lng: initialCoords[0], lat: initialCoords[1] });
    }

    const notifyPick = (lngLat) => {
      onLocationPick({ lng: lngLat.lng, lat: lngLat.lat });
    };

    marker.on('dragend', () => notifyPick(marker.getLngLat()));

    map.on('click', (e) => {
      marker.setLngLat(e.lngLat);
      notifyPick(e.lngLat);
    });

    mapRef.current = map;
    markerRef.current = marker;

    return () => {
      map.remove();
      mapRef.current = null;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <div ref={containerRef} className="h-full w-full" />;
}
